export default __webpack_public_path__ + "static/media/ktp400f.c5f4c4b1.png";